<template>
  <div class="slider-box">
    <div class="heading-3-regular title" v-if="sliderTitle">{{ sliderTitle }}</div>
    <div class="paragraph-1 content" v-if="sliderDescription" >{{ sliderDescription }}</div>
    <img v-if="sliderImage" :src="sliderImage"/>
  </div>
</template>

<script>
export default {
  name: 'SliderBox',
  props: {
    sliderTitle: {
      type: String,
      required: false,
    },
    sliderDescription: {
      type: String,
      required: false,
    },
    sliderImage: {
      type: String
    }
  }

}
</script>

<style lang="scss">
@import "SliderBox.scss";
</style>
